import * as _ from "lodash";
var removeOptional = /[\/]{0,1}\{[^\}?]*\?\}/gi;
export var RouteFiller = function (route, params) {
    _.forEach(params, function (p, i) {
        if (p !== undefined) {
            route = route.replace("{" + i + "}", p);
            route = route.replace("{" + i + "?}", p);
        }
        else {
            route = route.replace("/{" + i + "?}/", "");
            route = route.replace("{" + i + "?}/", "");
            route = route.replace("/{" + i + "?}", "");
            route = route.replace("{" + i + "}", "");
            route = route.replace("{" + i + "?}", "");
        }
    });
    return route.replace(removeOptional, "");
};
//# sourceMappingURL=Helpers.js.map